import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const useLgBreakpoint = () => {
  const theme = useMantineTheme();
  const mdBreakpoint = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`);
  return mdBreakpoint;
};
